import { useQuery } from '@apollo/react-hooks';
import { useContext } from 'react';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { CartIdContext } from '../Cart/CartIdContext';
export function useCart(cartQuery) {
    const { cartId } = useContext(CartIdContext);
    const result = useQuery(cartQuery, {
        variables: { cartId },
        skip: __IN_SERVER__
    });
    return { result, cart: result.data && result.data.cart };
}
export default function CartProvider({ children, query }) {
    throwErrorInDev(!query, `You forgot to pass 'query' to CartProvider`);
    const { result } = useCart(query);
    return children(result);
}
//# sourceMappingURL=CartProvider.js.map